import { HTTPError } from 'ky';

import { client } from '@/shared/http/client';

import type { MyReferrals, StoreReferralMe, StoreReferralProgram, StoreWallet } from './types';

/**
 * Indique & Ganhe da loja (PRAT-12). Tudo escopado pelo slug da loja; o cliente
 * vem do token (o `client` injeta o Bearer).
 */
const base = (slug: string) => `api/referrals/stores/${encodeURIComponent(slug)}`;

type Envelope<T> = { success: boolean; data: T; message?: string };

export async function getReferralProgram(slug: string): Promise<StoreReferralProgram> {
  const res = await client.get(`${base(slug)}/program`).json<Envelope<StoreReferralProgram>>();
  return res.data;
}

export async function getMyReferralCode(slug: string): Promise<StoreReferralMe> {
  const res = await client.get(`${base(slug)}/me`).json<Envelope<StoreReferralMe>>();
  return res.data;
}

export async function getStoreWallet(slug: string): Promise<StoreWallet> {
  const res = await client.get(`${base(slug)}/wallet`).json<Envelope<StoreWallet>>();
  return res.data;
}

export async function getMyReferrals(slug: string): Promise<MyReferrals> {
  const res = await client.get(`${base(slug)}/my-referrals`).json<Envelope<MyReferrals>>();
  return res.data;
}

export type RedeemResult = { ok: true } | { ok: false; message: string };

/**
 * Vincula o cliente logado ao código de quem o indicou. Recusa de regra
 * (autoindicação, já cliente, código inválido) volta como `ok: false` com a
 * mensagem da API, pronta para mostrar.
 */
export async function redeemReferralCode(slug: string, code: string): Promise<RedeemResult> {
  try {
    await client.post(`${base(slug)}/redeem`, { json: { code } }).json();
    return { ok: true };
  } catch (error) {
    if (error instanceof HTTPError && error.response.status === 422) {
      const body = (await error.response.json().catch(() => null)) as { message?: string } | null;
      return {
        ok: false,
        message: body?.message ?? 'Não foi possível usar este código de indicação.',
      };
    }
    throw error;
  }
}
